import React, { useState } from "react"
import { Modal, ModalBody, ModalHeader, Input, Button } from "reactstrap"

import toastr from "toastr"
import "toastr/build/toastr.min.css"
const LockModal = ({ isOpen, toggle }) => {
  const [inputPassword, setInputPassword] = useState("")
  const [error, setError] = useState("")

  const storedPwd = localStorage.getItem("password")

  const handleUnlock = () => {
    if (inputPassword === storedPwd) {
      toastr.success("Welcome Back")
      localStorage.setItem("isLocked", "false")
      setError("")
      toggle()
      window.location.reload()
    } else {
      setError("Incorrect password")
    }
  }

  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader>Screen Locked</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <Input
            type="password"
            placeholder="Enter login password"
            value={inputPassword}
            onChange={e => setInputPassword(e.target.value)}
          />
          <small>*same password used while login</small>
          {error && <small className="text-danger">{error}</small>}
        </div>

        <Button color="primary" onClick={handleUnlock}>
          Unlock {""}
          <i className="bx bx-lock-open-alt"></i>
        </Button>
      </ModalBody>
    </Modal>
  )
}

export default LockModal
